(function () {
  function initComparison(root) {
    if (!root || root.dataset.beforeAfterInit === 'true') return;

    const input = root.querySelector('[data-before-after-input]');
    if (!input) return;

    root.dataset.beforeAfterInit = 'true';

    const setPosition = (value) => {
      const pos = Math.min(100, Math.max(0, Number(value)));
      root.style.setProperty('--bd-before-after-pos', `${pos}%`);
      input.value = pos;
      input.setAttribute('aria-valuenow', String(pos));
    };

    setPosition(input.value || root.dataset.initialPosition || 50);

    // The first `input` event of a gesture is either a discrete click-to-jump
    // or the start of a drag — let it transition smoothly either way. Only
    // once a second `input` fires within the same gesture do we know the user
    // is actively dragging, so we disable the transition to avoid lag behind
    // the pointer.
    let inputCount = 0;

    input.addEventListener('input', function () {
      inputCount += 1;
      if (inputCount > 1) {
        root.classList.add('is-dragging');
      }
      setPosition(this.value);
    });

    const resetDragging = function () {
      root.classList.remove('is-dragging');
      inputCount = 0;
    };

    input.addEventListener('pointerup', resetDragging);
    input.addEventListener('pointercancel', resetDragging);
    input.addEventListener('blur', resetDragging);
  }

  function initAll(scope) {
    const container = scope || document;
    container.querySelectorAll('[data-before-after]').forEach(initComparison);
  }

  document.addEventListener('DOMContentLoaded', function () {
    initAll();
  });

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();
